module.exports = __webpack_public_path__ + "static/images/ercode_1.e7d95d5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ercode_1.jpeg
// module id = THm8
// module chunks = 8